module.exports = __webpack_public_path__ + "static/media/frogsfx.659e4a1a.wav";